import "./index.scss";

const WaveIcon = ({active}) => {
    return (
        <svg
            width="38"
            height="34"
            viewBox="0 0 38 34"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={`wave-icon-component ${active? 'active': ''}`}
        >
            <path id="wave1" d="M7 10L7 24" stroke="#FFFF00" strokeWidth="2" strokeLinecap="round" />
            <path id="wave2" d="M13 1L13 33" stroke="#FFFF00" strokeWidth="2" strokeLinecap="round" />
            <path id="wave3" d="M19 7L19 27" stroke="#FFFF00" strokeWidth="2" strokeLinecap="round" />
            <path id="wave4" d="M25 5L25 29" stroke="#FFFF00" strokeWidth="2" strokeLinecap="round" />
            <path id="wave5" d="M31 10V24" stroke="#FFFF00" strokeWidth="2" strokeLinecap="round" />
            <path id="wave6" d="M37 14L37 20" stroke="#FFFF00" strokeWidth="2" strokeLinecap="round" />
            <path id="wave7" d="M1 14L1 20" stroke="#FFFF00" strokeWidth="2" strokeLinecap="round" />
        </svg>
    )
}

export default WaveIcon